import { useState } from "react";

const useDidMountWithoutLifeCycle = (fnc: () => void) => {
  const [mounted, setMounted] = useState(false);

  if (!mounted) {
    setMounted(true);
    fnc();
  }
};

export default useDidMountWithoutLifeCycle;
